import { useTranslation } from 'react-i18next';

const SHORTCUTS = [
  { key: 'F2', label: 'customer' },
  { key: 'F3', label: 'product' },
  { key: 'F4', label: 'payment' },
  { key: 'F8', label: 'complete' },
  { key: '↑ ↓', label: 'select' },
  { key: '+ −', label: 'quantity' },
  { key: 'Del', label: 'remove' },
  { key: 'Esc', label: 'back' },
] as const;

/**
 * The shortcuts, where a new cashier will see them.
 *
 * A keyboard-first till that nobody knows is keyboard-first is a mouse-driven till. Kept to one
 * quiet strip rather than a help dialog, because the thing it teaches is used every few seconds and
 * a dialog would be opened once and never again.
 */
export function ShortcutLegend() {
  const { t } = useTranslation();

  return (
    <div
      className="text-muted flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs"
      aria-label={t('sales.counter.shortcuts.label')}
    >
      {SHORTCUTS.map((shortcut) => (
        <span key={shortcut.key} className="flex items-center gap-1.5">
          <kbd
            className="border-line bg-surface-2 text-ink rounded border px-1.5 py-0.5 font-mono text-[0.6875rem]"
            dir="ltr"
          >
            {shortcut.key}
          </kbd>
          {t(`sales.counter.shortcuts.${shortcut.label}`)}
        </span>
      ))}
    </div>
  );
}
